import React from 'react';
import { AccordionDetailsStyled, AccordionStyled, AccordionSummaryStyled, IconStyled } from './Accordion.styles';
const AccordionSummary = ({ ...props }) => {
    return (React.createElement(AccordionSummaryStyled, { expandIcon: React.createElement(IconStyled, null), ...props }));
};
const AccordionDetails = ({ ...props }) => {
    return (React.createElement(AccordionDetailsStyled, { ...props }));
};
/**
 * @param summary: The clickable component to be displayed
 * @param details: The component to be expanded
 *
 * @returns An expandable component with a clickable summary
 */
const Accordion = ({ summary, details, eventHandler = (_) => null, ...props }) => {
    return (React.createElement(AccordionStyled, null,
        React.createElement(AccordionSummary, null, summary),
        React.createElement(AccordionDetails, null, details)));
};
export default Accordion;
//# sourceMappingURL=Accordion.js.map